import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-update-book-per-price',
  templateUrl: './update-book-per-price.component.html',
  styleUrls: ['./update-book-per-price.component.scss']
})
export class UpdateBookPerPriceComponent implements OnInit {

  bookCommreceipt:any;

  bookCommdata:any[]=[];
  updatedCommBooks:any[]=[];

  crdtvAmt=0;
  selectedAmt=0;
  balanceAmt=0;

  total_remaining_amt=0;
  total_val=0;

  constructor(
    public service:DigisubservicesService,
    private dialogRef:MatDialogRef<UpdateBookPerPriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ){}

  ngOnInit():void{
    debugger

    this.bookCommreceipt=this.data.book;

    this.crdtvAmt=this.data.crdtAAmt || 0;
    this.selectedAmt=this.data.seAAmt || 0;
    this.balanceAmt=this.data.balAAmt || 0;

    const fetchBooks=this.service.getRcptCommWiseBooks1(
      this.bookCommreceipt.bill_no

    );

    fetchBooks.subscribe((data:any)=>{

      data.forEach((book:any)=>{

        const total_amount=
          Number(book.total)+Number(book.shipping_charges);

        const rcvd_amt=Number(book.comm_rcvd_amt)||0;

        const remaining_amt=
          Number(book.rep_commission_amt)-rcvd_amt;

        this.total_val+=rcvd_amt;
        this.total_remaining_amt+=remaining_amt;

        this.bookCommdata.push({

          id:this.bookCommreceipt.id,
          bookid:book.bd_id,

          book_name:book.book_name,
          book_price:book.book_price,
          book_copies:book.book_copies,

          total:book.total,
          shipping_charges:book.shipping_charges,

          total_amount:total_amount,

          inv_received_amt:book.inv_received_amt,

          rep_commission_amt:book.rep_commission_amt,
          comm_remaining_amt:remaining_amt,

          comm_rcvd_amt:book.comm_rcvd_amt,

          commper:book.commper,

          rcvd_amt:rcvd_amt,

          invoice_no:book.invoice_no,
          order_no:book.order_no,

          isDisabled:remaining_amt<=0
        });

      });

    });

  }

  // ===== Received Amount =====

  calcamount(event:any,book:any){

    const val=Number(event.target.value)||0;

    book.rcvd_amt=val;

    book.comm_remaining_amt=
      Number(book.rep_commission_amt)-val;

    book.isDisabled=book.comm_remaining_amt<=0;

    const index=this.updatedCommBooks.findIndex(
      (b:any)=>b.bookid===book.bookid
    );

    if(index>-1){
      this.updatedCommBooks[index]={...book};
    }else{
      this.updatedCommBooks.push({...book});
    }

    this.recalculateTotals();

    this.selectedAmt=this.total_val;
    this.balanceAmt=this.crdtvAmt-this.selectedAmt;

  }

  // ===== Commission Calculation =====

  calcCommission(book:any,event:any){

    const percent=Number(event.target.value)||0;

    book.commper=percent;

    const commission=
      (Number(book.total_amount)*percent)/100;

    book.rep_commission_amt=commission;

    book.comm_remaining_amt=
      commission-Number(book.rcvd_amt||0);

    book.isDisabled=book.comm_remaining_amt<=0;

    this.recalculateTotals();

  }

  // ===== Totals =====

  recalculateTotals(){

    this.total_val=0;
    this.total_remaining_amt=0;

    this.bookCommdata.forEach(book=>{

      this.total_val+=Number(book.rcvd_amt)||0;

      this.total_remaining_amt+=
        Number(book.comm_remaining_amt)||0;

    });

  }

  // ===== Save =====

  save(){

    if(this.updatedCommBooks.length===0){
      this.updatedCommBooks=this.bookCommdata;
    }

    const payload={

      data:this.updatedCommBooks,
      selectedAmt:this.selectedAmt,
      remaining_amt:this.total_remaining_amt,
      value:this.total_val,
      balanceAmt:this.balanceAmt,

      id:this.bookCommreceipt.id,
      invoice_no:this.bookCommreceipt.invoice_no

    };

    console.log("Payload:",payload);

    this.dialogRef.close(payload);

  }

}